var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexagon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41723 1.8237C8.62993 1.70553 8.73628 1.64645 8.84891 1.62329C8.94859 1.60278 9.05141 1.60278 9.15109 1.62329C9.26372 1.64645 9.37007 1.70553 9.58277 1.8237L15.1328 4.90704C15.3574 5.03184 15.4697 5.09424 15.5515 5.18299C15.6239 5.26151 15.6786 5.35457 15.7121 5.45595C15.75 5.57055 15.75 5.69904 15.75 5.95603V12.0439C15.75 12.3008 15.75 12.4293 15.7121 12.5439C15.6786 12.6453 15.6239 12.7384 15.5515 12.8169C15.4697 12.9056 15.3574 12.968 15.1328 13.0928L9.58277 16.1762C9.37007 16.2943 9.26372 16.3534 9.15109 16.3766C9.05141 16.3971 8.94859 16.3971 8.84891 16.3766C8.73628 16.3534 8.62993 16.2943 8.41723 16.1762L2.86723 13.0928C2.64259 12.968 2.53026 12.9056 2.44847 12.8169C2.37612 12.7384 2.32136 12.6453 2.28786 12.5439C2.25 12.4293 2.25 12.3008 2.25 12.0439V5.95602C2.25 5.69904 2.25 5.57055 2.28786 5.45595C2.32136 5.35457 2.37612 5.26151 2.44847 5.18299C2.53026 5.09424 2.64259 5.03184 2.86723 4.90704L8.41723 1.8237Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon01);
export default __webpack_public_path__ + "static/media/hexagon-01.1fe68b72b71d4c74fa53ce006069f67a.svg";
export { ForwardRef as ReactComponent };